export const prefixOptions = [
  { prefix: "+39", flag: "🇮🇹", code: "it", name: "Italia" },
  { prefix: "+1", flag: "🇺🇸", code: "us", name: "USA/Canada" },
  { prefix: "+1242", flag: "🇧🇸", code: "bs", name: "Bahamas" },
  { prefix: "+1284", flag: "🇻🇬", code: "vg", name: "Isole Vergini Britanniche" },
  { prefix: "+1345", flag: "🇰🇾", code: "ky", name: "Isole Cayman" },
  { prefix: "+1441", flag: "🇧🇲", code: "bm", name: "Bermuda" },
  { prefix: "+1868", flag: "🇹🇹", code: "tt", name: "Trinidad e Tobago" },
  { prefix: "+1876", flag: "🇯🇲", code: "jm", name: "Giamaica" },
  { prefix: "+20", flag: "🇪🇬", code: "eg", name: "Egitto" },
  { prefix: "+212", flag: "🇲🇦", code: "ma", name: "Marocco" },
  { prefix: "+213", flag: "🇩🇿", code: "dz", name: "Algeria" },
  { prefix: "+216", flag: "🇹🇳", code: "tn", name: "Tunisia" },
  { prefix: "+218", flag: "🇱🇾", code: "ly", name: "Libia" },
  { prefix: "+221", flag: "🇸🇳", code: "sn", name: "Senegal" },
  { prefix: "+223", flag: "🇲🇱", code: "ml", name: "Mali" },
  { prefix: "+224", flag: "🇬🇳", code: "gn", name: "Guinea" },
  { prefix: "+225", flag: "🇨🇮", code: "ci", name: "Costa d'Avorio" },
  { prefix: "+226", flag: "🇧🇫", code: "bf", name: "Burkina Faso" },
  { prefix: "+228", flag: "🇹🇬", code: "tg", name: "Togo" },
  { prefix: "+229", flag: "🇧🇯", code: "bj", name: "Benin" },
  { prefix: "+230", flag: "🇲🇺", code: "mu", name: "Mauritius" },
  { prefix: "+231", flag: "🇱🇷", code: "lr", name: "Liberia" },
  { prefix: "+232", flag: "🇸🇱", code: "sl", name: "Sierra Leone" },
  { prefix: "+233", flag: "🇬🇭", code: "gh", name: "Ghana" },
  { prefix: "+234", flag: "🇳🇬", code: "ng", name: "Nigeria" },
  { prefix: "+235", flag: "🇹🇩", code: "td", name: "Ciad" },
  { prefix: "+236", flag: "🇨🇫", code: "cf", name: "Repubblica Centrafricana" },
  { prefix: "+237", flag: "🇨🇲", code: "cm", name: "Camerun" },
  { prefix: "+238", flag: "🇨🇻", code: "cv", name: "Capo Verde" },
  { prefix: "+241", flag: "🇬🇦", code: "ga", name: "Gabon" },
  { prefix: "+242", flag: "🇨🇬", code: "cg", name: "Repubblica del Congo" },
  { prefix: "+243", flag: "🇨🇩", code: "cd", name: "Repubblica Democratica del Congo" },
  { prefix: "+244", flag: "🇦🇴", code: "ao", name: "Angola" },
  { prefix: "+248", flag: "🇸🇨", code: "sc", name: "Seychelles" },
  { prefix: "+249", flag: "🇸🇩", code: "sd", name: "Sudan" },
  { prefix: "+250", flag: "🇷🇼", code: "rw", name: "Ruanda" },
  { prefix: "+251", flag: "🇪🇹", code: "et", name: "Etiopia" },
  { prefix: "+252", flag: "🇸🇴", code: "so", name: "Somalia" },
  { prefix: "+254", flag: "🇰🇪", code: "ke", name: "Kenya" },
  { prefix: "+255", flag: "🇹🇿", code: "tz", name: "Tanzania" },
  { prefix: "+256", flag: "🇺🇬", code: "ug", name: "Uganda" },
  { prefix: "+257", flag: "🇧🇮", code: "bi", name: "Burundi" },
  { prefix: "+258", flag: "🇲🇿", code: "mz", name: "Mozambico" },
  { prefix: "+260", flag: "🇿🇲", code: "zm", name: "Zambia" },
  { prefix: "+261", flag: "🇲🇬", code: "mg", name: "Madagascar" },
  { prefix: "+263", flag: "🇿🇼", code: "zw", name: "Zimbabwe" },
  { prefix: "+265", flag: "🇲🇼", code: "mw", name: "Malawi" },
  { prefix: "+266", flag: "🇱🇸", code: "ls", name: "Lesotho" },
  { prefix: "+267", flag: "🇧🇼", code: "bw", name: "Botswana" },
  { prefix: "+27", flag: "🇿🇦", code: "za", name: "Sudafrica" },
  { prefix: "+291", flag: "🇪🇷", code: "er", name: "Eritrea" },
  { prefix: "+30", flag: "🇬🇷", code: "gr", name: "Grecia" },
  { prefix: "+31", flag: "🇳🇱", code: "nl", name: "Paesi Bassi" },
  { prefix: "+32", flag: "🇧🇪", code: "be", name: "Belgio" },
  { prefix: "+33", flag: "🇫🇷", code: "fr", name: "Francia" },
  { prefix: "+34", flag: "🇪🇸", code: "es", name: "Spagna" },
  { prefix: "+350", flag: "🇬🇮", code: "gi", name: "Gibilterra" },
  { prefix: "+351", flag: "🇵🇹", code: "pt", name: "Portogallo" },
  { prefix: "+352", flag: "🇱🇺", code: "lu", name: "Lussemburgo" },
  { prefix: "+353", flag: "🇮🇪", code: "ie", name: "Irlanda" },
  { prefix: "+354", flag: "🇮🇸", code: "is", name: "Islanda" },
  { prefix: "+355", flag: "🇦🇱", code: "al", name: "Albania" },
  { prefix: "+356", flag: "🇲🇹", code: "mt", name: "Malta" },
  { prefix: "+357", flag: "🇨🇾", code: "cy", name: "Cipro" },
  { prefix: "+358", flag: "🇫🇮", code: "fi", name: "Finlandia" },
  { prefix: "+359", flag: "🇧🇬", code: "bg", name: "Bulgaria" },
  { prefix: "+36", flag: "🇭🇺", code: "hu", name: "Ungheria" },
  { prefix: "+370", flag: "🇱🇹", code: "lt", name: "Lituania" },
  { prefix: "+371", flag: "🇱🇻", code: "lv", name: "Lettonia" },
  { prefix: "+372", flag: "🇪🇪", code: "ee", name: "Estonia" },
  { prefix: "+373", flag: "🇲🇩", code: "md", name: "Moldavia" },
  { prefix: "+374", flag: "🇦🇲", code: "am", name: "Armenia" },
  { prefix: "+375", flag: "🇧🇾", code: "by", name: "Bielorussia" },
  { prefix: "+376", flag: "🇦🇩", code: "ad", name: "Andorra" },
  { prefix: "+377", flag: "🇲🇨", code: "mc", name: "Monaco" },
  { prefix: "+378", flag: "🇸🇲", code: "sm", name: "San Marino" },
  { prefix: "+379", flag: "🇻🇦", code: "va", name: "Città del Vaticano" },
  { prefix: "+380", flag: "🇺🇦", code: "ua", name: "Ucraina" },
  { prefix: "+381", flag: "🇷🇸", code: "rs", name: "Serbia" },
  { prefix: "+382", flag: "🇲🇪", code: "me", name: "Montenegro" },
  { prefix: "+385", flag: "🇭🇷", code: "hr", name: "Croazia" },
  { prefix: "+386", flag: "🇸🇮", code: "si", name: "Slovenia" },
  { prefix: "+387", flag: "🇧🇦", code: "ba", name: "Bosnia ed Erzegovina" },
  { prefix: "+389", flag: "🇲🇰", code: "mk", name: "Macedonia del Nord" },
  { prefix: "+40", flag: "🇷🇴", code: "ro", name: "Romania" },
  { prefix: "+41", flag: "🇨🇭", code: "ch", name: "Svizzera" },
  { prefix: "+420", flag: "🇨🇿", code: "cz", name: "Repubblica Ceca" },
  { prefix: "+421", flag: "🇸🇰", code: "sk", name: "Slovacchia" },
  { prefix: "+423", flag: "🇱🇮", code: "li", name: "Liechtenstein" },
  { prefix: "+43", flag: "🇦🇹", code: "at", name: "Austria" },
  { prefix: "+44", flag: "🇬🇧", code: "gb", name: "Regno Unito" },
  { prefix: "+45", flag: "🇩🇰", code: "dk", name: "Danimarca" },
  { prefix: "+46", flag: "🇸🇪", code: "se", name: "Svezia" },
  { prefix: "+47", flag: "🇳🇴", code: "no", name: "Norvegia" },
  { prefix: "+48", flag: "🇵🇱", code: "pl", name: "Polonia" },
  { prefix: "+49", flag: "🇩🇪", code: "de", name: "Germania" },
  { prefix: "+502", flag: "🇬🇹", code: "gt", name: "Guatemala" },
  { prefix: "+503", flag: "🇸🇻", code: "sv", name: "El Salvador" },
  { prefix: "+504", flag: "🇭🇳", code: "hn", name: "Honduras" },
  { prefix: "+505", flag: "🇳🇮", code: "ni", name: "Nicaragua" },
  { prefix: "+506", flag: "🇨🇷", code: "cr", name: "Costa Rica" },
  { prefix: "+507", flag: "🇵🇦", code: "pa", name: "Panama" },
  { prefix: "+509", flag: "🇭🇹", code: "ht", name: "Haiti" },
  { prefix: "+51", flag: "🇵🇪", code: "pe", name: "Perù" },
  { prefix: "+52", flag: "🇲🇽", code: "mx", name: "Messico" },
  { prefix: "+53", flag: "🇨🇺", code: "cu", name: "Cuba" },
  { prefix: "+54", flag: "🇦🇷", code: "ar", name: "Argentina" },
  { prefix: "+55", flag: "🇧🇷", code: "br", name: "Brasile" },
  { prefix: "+56", flag: "🇨🇱", code: "cl", name: "Cile" },
  { prefix: "+57", flag: "🇨🇴", code: "co", name: "Colombia" },
  { prefix: "+58", flag: "🇻🇪", code: "ve", name: "Venezuela" },
  { prefix: "+591", flag: "🇧🇴", code: "bo", name: "Bolivia" },
  { prefix: "+592", flag: "🇬🇾", code: "gy", name: "Guyana" },
  { prefix: "+593", flag: "🇪🇨", code: "ec", name: "Ecuador" },
  { prefix: "+594", flag: "🇬🇫", code: "gf", name: "Guyana Francese" },
  { prefix: "+595", flag: "🇵🇾", code: "py", name: "Paraguay" },
  { prefix: "+596", flag: "🇲🇶", code: "mq", name: "Martinica" },
  { prefix: "+597", flag: "🇸🇷", code: "sr", name: "Suriname" },
  { prefix: "+598", flag: "🇺🇾", code: "uy", name: "Uruguay" },
  { prefix: "+60", flag: "🇲🇾", code: "my", name: "Malesia" },
  { prefix: "+61", flag: "🇦🇺", code: "au", name: "Australia" },
  { prefix: "+62", flag: "🇮🇩", code: "id", name: "Indonesia" },
  { prefix: "+63", flag: "🇵🇭", code: "ph", name: "Filippine" },
  { prefix: "+64", flag: "🇳🇿", code: "nz", name: "Nuova Zelanda" },
  { prefix: "+65", flag: "🇸🇬", code: "sg", name: "Singapore" },
  { prefix: "+66", flag: "🇹🇭", code: "th", name: "Thailandia" },
  { prefix: "+675", flag: "🇵🇬", code: "pg", name: "Papua Nuova Guinea" },
  { prefix: "+687", flag: "🇳🇨", code: "nc", name: "Nuova Caledonia" },
  { prefix: "+689", flag: "🇵🇫", code: "pf", name: "Polinesia Francese" },
  { prefix: "+7", flag: "🇷🇺", code: "ru", name: "Russia" },
  { prefix: "+737", flag: "🇰🇿", code: "kz", name: "Kazakistan" },
  { prefix: "+81", flag: "🇯🇵", code: "jp", name: "Giappone" },
  { prefix: "+82", flag: "🇰🇷", code: "kr", name: "Corea del Sud" },
  { prefix: "+84", flag: "🇻🇳", code: "vn", name: "Vietnam" },
  { prefix: "+850", flag: "🇰🇵", code: "kp", name: "Corea del Nord" },
  { prefix: "+852", flag: "🇭🇰", code: "hk", name: "Hong Kong" },
  { prefix: "+855", flag: "🇰🇭", code: "kh", name: "Cambogia" },
  { prefix: "+86", flag: "🇨🇳", code: "cn", name: "Cina" },
  { prefix: "+880", flag: "🇧🇩", code: "bd", name: "Bangladesh" },
  { prefix: "+886", flag: "🇹🇼", code: "tw", name: "Taiwan" },
  { prefix: "+90", flag: "🇹🇷", code: "tr", name: "Turchia" },
  { prefix: "+91", flag: "🇮🇳", code: "in", name: "India" },
  { prefix: "+92", flag: "🇵🇰", code: "pk", name: "Pakistan" },
  { prefix: "+93", flag: "🇦🇫", code: "af", name: "Afghanistan" },
  { prefix: "+94", flag: "🇱🇰", code: "lk", name: "Sri Lanka" },
  { prefix: "+95", flag: "🇲🇲", code: "mm", name: "Myanmar" },
  { prefix: "+961", flag: "🇱🇧", code: "lb", name: "Libano" },
  { prefix: "+962", flag: "🇯🇴", code: "jo", name: "Giordania" },
  { prefix: "+963", flag: "🇸🇾", code: "sy", name: "Siria" },
  { prefix: "+964", flag: "🇮🇶", code: "iq", name: "Iraq" },
  { prefix: "+965", flag: "🇰🇼", code: "kw", name: "Kuwait" },
  { prefix: "+966", flag: "🇸🇦", code: "sa", name: "Arabia Saudita" },
  { prefix: "+967", flag: "🇾🇪", code: "ye", name: "Yemen" },
  { prefix: "+971", flag: "🇦🇪", code: "ae", name: "Emirati Arabi Uniti" },
  { prefix: "+972", flag: "🇮🇱", code: "il", name: "Israele" },
  { prefix: "+974", flag: "🇶🇦", code: "qa", name: "Qatar" },
  { prefix: "+976", flag: "🇲🇳", code: "mn", name: "Mongolia" },
  { prefix: "+977", flag: "🇳🇵", code: "np", name: "Nepal" },
  { prefix: "+98", flag: "🇮🇷", code: "ir", name: "Iran" },
  { prefix: "+994", flag: "🇦🇿", code: "az", name: "Azerbaigian" },
  { prefix: "+995", flag: "🇬🇪", code: "ge", name: "Georgia" },
  { prefix: "+996", flag: "🇰🇬", code: "kg", name: "Kirghizistan" },
  { prefix: "+998", flag: "🇺🇿", code: "uz", name: "Uzbekistan" }
];

const sortedPrefixes = [...prefixOptions].sort((a, b) => b.prefix.length - a.prefix.length);

export const splitPhoneNumber = (fullNumber: string) => {
  if (!fullNumber) return { prefix: '+39', number: '' };
  
  for (const option of sortedPrefixes) {
    if (fullNumber.startsWith(option.prefix)) {
      return {
        prefix: option.prefix,
        number: fullNumber.slice(option.prefix.length)
      };
    }
  }
  
  return { prefix: '+39', number: fullNumber };
};

export const getCodeFromPrefix = (prefix: string) => {
  const found = prefixOptions.find(p => p.prefix === prefix);
  return found ? found.code : 'it';
};

export const isValidPhone = (fullNumber: string) => {
  const { prefix, number } = splitPhoneNumber(fullNumber);
  if (prefix === '+39') {
    return /^\d{9,10}$/.test(number);
  }
  return /^\d{4,15}$/.test(number);
};
